import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {
  ColumnBlock,
  ColumnContent,
  ContentSection,
} from '../../layout/components';
import { Icon } from '../../../icons';
import styles from '../../../styles';
import { Button } from './';

const StyledFigure = styled.figure`
  color: ${styles.color.ORANGE};
  width: 12rem;
  margin: 0 auto 4rem;
`;

const StyledContentSection = styled(ContentSection)`
  margin-bottom: 11rem;
`;

const StyledColumnContent = styled(ColumnContent)`
  button  {
    margin: 0 auto;
  }
`;

const NewsLetterBlock = ({ text }) => {
  return (
    <StyledContentSection>
      <ColumnBlock columns={1} />
      <ColumnBlock columns={2}>
        <StyledColumnContent>
          <StyledFigure>
            <Icon icon="#icon-careers-marketing" />
          </StyledFigure>
          <div dangerouslySetInnerHTML={{ __html: text }} />
          <Button to="/keep-up-to-date">Get updates from Space Ape</Button>
        </StyledColumnContent>
      </ColumnBlock>
    </StyledContentSection>
  );
};

NewsLetterBlock.propTypes = {
  text: PropTypes.string.isRequired,
};

export default NewsLetterBlock;



// WEBPACK FOOTER //
// ./src/modules/pages/components/NewsLetterBlock.js